<!--
Generic form header component used in all five Payment forms to display current tab status, sub desc if any
, and form created by and current page the user is on.
-->

<template>
  <div>
    <div v-for="(tab, index) in tabItems" :key="index" class="px-md-5 px-0">
              <span v-if="tab.component === currentTab">
                <h4>{{tab.name}}</h4>

                <div class="row no-gutters mb-1" v-if="tab.subDesc">
                  <span v-html="tab.subDesc"></span>
                </div>

                Request by {{currentUser.firstName}} {{currentUser.lastName}}
                <div class="float-md-right">page {{index+1}}/{{tabItems.length}}</div> <br />
                <hr>
              </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormHeader",
  props: {
    tabItems: Array,
    currentUser: Object,
    currentTab: String
  }
}
</script>

<style scoped>

</style>